import { render, staticRenderFns } from "./PostbackActionCell.vue?vue&type=template&id=113cbd09&scoped=true&"
import script from "./PostbackActionCell.vue?vue&type=script&lang=js&"
export * from "./PostbackActionCell.vue?vue&type=script&lang=js&"
import style0 from "./PostbackActionCell.vue?vue&type=style&index=0&id=113cbd09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113cbd09",
  null
  
)

export default component.exports